import { useMemo } from 'react';

import { type BudgetTeamMember, peopleAcross, readBudget, type VersionTeam } from './budget';

/** On the team of a version the year touches, or holding hours in it, which the totals count. */
export const yearPeople = (
  yearTeams: VersionTeam[],
  hours: Record<string, number | null | undefined>[],
): BudgetTeamMember[] => {
  const onTeam = new Set(yearTeams.flatMap(team => team.teamIds ?? team.people.map(person => person.id)));
  return peopleAcross(yearTeams).filter(person => onTeam.has(person.id) || hours.some(sprint => !!sprint[person.id]));
};

/** The rows the year's grid draws; the version teams' `people` stay whole, since they price every sprint. */
export const useYearPeople = (
  productId: string,
  yearTeams: VersionTeam[],
  sprintIds: string[],
  hours: Record<string, Record<string, number | null | undefined>>,
): BudgetTeamMember[] => {
  // Budgeted hours keep a row on both tabs, or the Costs deviations lose the shortfall of whoever has not reported.
  const kept = useMemo(
    () => [...sprintIds.map(id => readBudget(productId, id)?.hours ?? {}), ...Object.values(hours)],
    [productId, sprintIds, hours],
  );
  return useMemo(() => yearPeople(yearTeams, kept), [yearTeams, kept]);
};
